import type { FullTeamGroupResponse } from '../../../../../shared/types/routes/teamGroups';
import { queryClient, useMutation } from '../../../../ReactQuery';
import { remove } from '../../../../redux/api';
import { getTeamGroupQueryKey } from './useTeamGroup';

//  Function for removing a Team Group Team.
function deleteTeamGroupTeam(teamGroupId: number, teamId: number) {
  return remove<void, void>(`/api/teams/groups/${teamGroupId}/teams/${teamId}`);
}

/**
 * Hook used to remove a Team Group Team.
 */
export default function useDeleteTeamGroupTeam(teamGroupId: number, teamId: number) {
  return useMutation({
    mutationFn: () => deleteTeamGroupTeam(teamGroupId, teamId),
    onSuccess: () => {
      // Update the cache
      queryClient.setQueryData(
        getTeamGroupQueryKey(teamGroupId),
        (oldTeamGroup: FullTeamGroupResponse | undefined) => {
          if (!oldTeamGroup) {
            return undefined;
          }
          return {
            ...oldTeamGroup,
            teams: oldTeamGroup.teams.filter((team) => team.id !== teamId),
          };
        },
      );
      // Then we invalidate the team group query, so that the new full team group data is refetched.
      queryClient.invalidateQueries(getTeamGroupQueryKey(teamGroupId));
    },
  });
}
